import storage from './storage';
import {getApiUrl} from '../config/serverEndpoint';
export async function queueSuggestion(username,word,note,gameId) {
  if(!username||username==='guest')throw Error('Kelime önermek için hesabınla giriş yapmalısın.');
  word=String(word).trim().toLocaleLowerCase('tr-TR');note=String(note||'').trim();
  if(!/^[abcçdefgğhıijklmnoöprsştuüvyz]{2,10}$/u.test(word))throw Error('Türkçe harflerden oluşan 2–10 harflik bir kelime yaz.');
  if(note.length>200)throw Error('Açıklama en fazla 200 karakter olabilir.');
  const key=`suggestions:${username}`,entries=await storage.read(key)||[];
  if(entries.some(item=>item.word===word))return 'Bu kelime önerin zaten kaydedildi.';
  if(entries.length>=10)throw Error('Bekleyen en fazla 10 kelime önerisi olabilir.');
  await storage.write(key,[...entries,{word,note,gameId,createdAt:Date.now()}]);
  return 'Kelime önerin kaydedildi. İnternet geldiğinde hesabınla iletilecek.';
}
let flushing;
export function flushSuggestions(username) {
  if(flushing)return flushing;
  flushing=(async()=>{
    if(navigator.onLine===false||sessionStorage.getItem('username')!==username)return;
    const token=sessionStorage.getItem('reconnectToken');if(!token)return;
    const key=`suggestions:${username}`,entries=await storage.read(key)||[];
    for(const item of entries){
      if(navigator.onLine===false||sessionStorage.getItem('username')!==username||sessionStorage.getItem('reconnectToken')!==token)return;
      const controller=new AbortController(),timer=setTimeout(()=>controller.abort(),8000);
      try{
        const response=await fetch(getApiUrl('/suggest-word'),{method:'POST',headers:{'Content-Type':'application/json'},signal:controller.signal,body:JSON.stringify({username,reconnectToken:token,...item})});
        if(response.status===401||response.status===429||response.status>=500)return;
        const latest=await storage.read(key)||[];await storage.write(key,latest.filter(value=>value.word!==item.word));
      }catch(_){return;}finally{clearTimeout(timer);}
    }
  })().finally(()=>{flushing=null;});return flushing;
}
